export default __webpack_public_path__ + "static/media/icon-plus-blue.03fd518b.svg";